<template>
  <div
    class="product-form"
    :class="{ [$class('loading')]: !product }"
  >
    <template v-if="isPreOrder">
      <p
        v-if="modelDetails"
        class="product-form__description text-body-s"
        v-text="modelDetails"
      />

      <div class="klaviyo-forms product-form__add-to-cart">
        <btn
          class="klaviyo-form-trigger"
          block-class="product-form"
          :label="$string('product.form.pre_order')"
          modifiers="boxed"
          @click="handlePreOrder"
        />
      </div>
    </template>

    <form
      v-else
      class="product-form__form"
      @submit.prevent="handleAddToCart"
    >
      <div
        v-if="productSiblings && productSiblings.length > 1"
        class="product-form__option"
      >
        <product-form-option
          :name="$string('product.form.color')"
          :values="productSiblings"
        />
      </div>

      <div
        v-for="(option, index) of options"
        v-show="showOptions"
        :key="`option-${index}`"
        class="product-form__option"
        :class="{
          'gift-card': isGiftCard,
        }"
      >
        <span
          v-if="isGiftCard"
          class="product-form__gift-card-warning text-body-s"
          v-text="$string('product.form.gift_card_currency_warning')"
        />

        <product-form-option
          :name="option.name"
          :values="formatOptionValues(option)"
          :link="getOptionLink(option)"
          :modal="sizeTitle || sizeBody || sizePageCm || sizePageIn ? {
            handler: () => {
              this.openOverlay({
                component: 'size-guide',
                ignoreDismissed: true,
                namespace: 'sizeGuideOverlay',
              })
              this.setDefaultState()
            },
          } : {}"
          :is-gift-card="isGiftCard"
          :allow-selection="$variable('product.enableStockNotifications')"
          @change="handleOptionChange"
        />
      </div>

      <p
        v-if="modelDetails"
        class="product-form__description text-body-s"
        v-text="modelDetails"
      />

      <div class="product-form__footer">
        <btn
          class="product-form__add-to-cart"
          block-class="product-form"
          :label="addToCartText"
          modifiers="boxed"
          :show-state-icon="state === 'adding'"
          type="submit"
          :disabled="
            product.vipProduct && !liquid?.waitingList && !liquid.customer.vip
          "
        >
          <template
            v-if="addToCartIcon"
            #icon
          >
            <component :is="addToCartIcon" />
          </template>

          <template #stateIcon>
            <icon-loading />
          </template>
        </btn>
      </div>
    </form>

    <p
      v-if="error"
      class="product-form__error text-body-s"
      v-text="error"
    />

    <overlay
      direction="up"
      namespace="sizeGuideOverlay"
      type="modal"
      block-class="size-guide-overlay"
      :is-size-guide="true"
      >
      <template #body>
        <div :js-size-guide="liquid.sectionId">
        <div
        class="
          size-guide
          critical-component-clear
        "
        :style="{
          '--section-spacing': sectionSpacing,
          '--section-spacing-l': sectionSpacingL,
        }">
          <div
            class="
            size-guide__header
            ">
            <div class="size-guide__gallery">

              <art-direction
                :image="sizeGuideLeftImage"
                ratio="4:5"
                crop
                :lazyload="true"
              />
              <art-direction
                :image="sizeGuideRightImage"
                ratio="4:5"
                crop
                :lazyload="true"
              />

            <!-- <div class="images liquid" style="animation-delay: 0s; padding-bottom: 125%;">
              <img class="images__image was-loading" alt="" decoding="async" loading="lazy" onload="this.classList.remove('is-loading')" role="presentation" sizes="50vw" src="//vollebak.com/cdn/shop/files/100_year_long_sleeve_top_white_6476.webp?v=1684325966&amp;width=640" srcset="//vollebak.com/cdn/shop/files/100_year_long_sleeve_top_white_6476.webp?v=1684325966&amp;width=1280 1280w,//vollebak.com/cdn/shop/files/100_year_long_sleeve_top_white_6476.webp?v=1684325966&amp;width=1920 1920w,//vollebak.com/cdn/shop/files/100_year_long_sleeve_top_white_6476.webp?v=1684325966&amp;width=2560 2560w,//vollebak.com/cdn/shop/files/100_year_long_sleeve_top_white_6476.webp?v=1684325966&amp;width=3200 3200w,//vollebak.com/cdn/shop/files/100_year_long_sleeve_top_white_6476.webp?v=1684325966&amp;width=3840 3840w"></div><div class="images liquid" style="animation-delay: 0s; padding-bottom: 125%;"><img class="images__image was-loading" alt="" decoding="async" loading="lazy" onload="this.classList.remove('is-loading')" role="presentation" sizes="50vw" src="//vollebak.com/cdn/shop/files/100_year_long_sleeve_top_white_6409.webp?v=1684325959&amp;width=640" srcset="//vollebak.com/cdn/shop/files/100_year_long_sleeve_top_white_6409.webp?v=1684325959&amp;width=1280 1280w,//vollebak.com/cdn/shop/files/100_year_long_sleeve_top_white_6409.webp?v=1684325959&amp;width=1920 1920w,//vollebak.com/cdn/shop/files/100_year_long_sleeve_top_white_6409.webp?v=1684325959&amp;width=2560 2560w,//vollebak.com/cdn/shop/files/100_year_long_sleeve_top_white_6409.webp?v=1684325959&amp;width=3200 3200w,//vollebak.com/cdn/shop/files/100_year_long_sleeve_top_white_6409.webp?v=1684325959&amp;width=3840 3840w"></div></div> -->
            </div>
              <div class="size-guide__content">
                  <h2
                      class="text-heading-2xl text-heading-4xl-desktop"
                      v-text="sizeTitle"
                     />
                  <p
                      v-if="true"
                      class="size-guide__body text-body-s text-body-m-desktop"
                      v-text="sizeBody"
                      />
            </div>
          </div>
          <div class="size-guide__main">

            <div class="container">
                <div class="size-guide__selector">
                  <button
                      class="
                        size-guide__button
                        text-body-xs-bold
                        text-body-s-bold-desktop
                        is-active
                      "
                      type="button"
                      :aria-controls="liquid.sectionId + '-cm'"
                      aria-label="CM"
                      js-size-guide="button"
                      >
                      Cm
                      </button>
                      <button
                      class="size-guide__button text-body-xs-bold text-body-s-bold-desktop"
                      type="button"
                      :aria-controls="liquid.sectionId + '-in'"
                      aria-label="In"
                      js-size-guide="button"
                      >
                      In
                      </button>
                  <span class="size-guide__state" js-size-guide="state" />
                </div>
            </div>
            <div
                :id="liquid.sectionId + '-cm'"
                class="size-guide__page rte container is-active"
                js-size-guide="page"
                v-html="sizePageCmText"
                >
            </div>
            <div
                :id="liquid.sectionId + '-in'"
                class="size-guide__page rte container"
                js-size-guide="page"
                v-html="sizePageIn"
                >
          </div>
          </div>
        </div>
        </div>
      </template>
    </overlay>

    <overlay
      v-if="$variable('product.enableStockNotifications')"
      direction="up"
      namespace="stockNotificationOverlay"
      type="modal"
      block-class="stock-notification-overlay"
    >
      <template #body>
        <form
          class="stock-notification"
          @submit.prevent="handleStockNotification"
        >
          <input
            v-if="liquid?.waitingList"
            name="g"
            type="hidden"
            :value="liquid?.waitingList"
          >

          <input
            name="a"
            type="hidden"
            :value="$variable('klaviyo.key')"
          >

          <input
            name="variant"
            type="hidden"
            :value="currentVariantId"
          >

          <input
            name="platform"
            type="hidden"
            value="shopify"
          >

          <div class="stock-notification__header">
            <h2 class="text-heading-xl text-heading-3xl-desktop">
              {{ $string('product.stock_notification.title') }}
            </h2>

            <p
              class="
                stock-notification__subtitle
                text-body-s text-body-m-desktop
              "
            >
              {{ $string('product.stock_notification.subtitle') }}
            </p>
          </div>

          <div class="form-group">
            <div className="form-group__field">
              <input
                id="stock-notification-email"
                v-model="email"
                class="form-group__input"
                type="email"
                :placeholder="$string('product.stock_notification.email')"
                name="email"
                required
                @change="resetStockNotification"
                @keyup="resetStockNotification"
              >

              <label
                class="form-group__label"
                for="stock-notification-email"
                v-text="$string('product.stock_notification.email')"
              />
            </div>

            <p
              v-if="stockNotification.state === 'SUCCESS'"
              class="stock-notification__message text-body-xs"
              v-text="$string('product.stock_notification.success')"
            />

            <p
              v-else-if="stockNotification.state === 'ERROR'"
              class="
                stock-notification__message stock-notification__message--error
                text-body-xs
              "
              v-text="$string('product.stock_notification.error')"
            />

            <div class="form-group__footer">
              <btn
                v-if="stockNotification.state === 'SUCCESS'"
                type="button"
                :label="$string('product.stock_notification.close')"
                modifiers="boxed"
                @click.prevent="closeOverlay('stockNotificationOverlay')"
              />

              <btn
                v-else
                :label="$string('product.cta.stock_notification')"
                :disabled="stockNotification.state === 'LOADING'"
                type="submit"
                modifiers="boxed"
              />
            </div>
          </div>
        </form>
      </template>
    </overlay>
  </div>
</template>

<script>

/**
 * Vue: Product form (product-form)
 * -----------------------------------------------------------------------------
 * Product form to handle variant selection and adding to cart.
 *
 * @param {Boolean} liquid.hasOnlyDefaultVariant - Has only default variant.
 * @param {String} parentState - Parent component's loading state.
 * @param {Object|Boolean} product - Canvas formatted product object.
 * @param {Object|Boolean} variant - Canvas formatted variant object.
 * @param {String} sizeGuide - The size guide link.
 * @param {String} sizeTitle - The size guide title.
 * @param {String} sizeBody - The size guide body.
 * @param {String} sizePageCm - The size guide page content.
 * @param {String} sizePageIn - The size guide page content.
 * @param {Boolean} enablePreorder - Whether to enable pre-order.
 * @param {String} klaviyoFormId - The Klaviyo form ID.
 * @param {String} klaviyoFormIdMobile - The Klaviyo form ID for mobile.
 *
 */
import { mapActions, mapGetters, mapState } from 'vuex'

import Btn from '~global/btn/btn'
import Overlay from '~global/overlay/overlay'
import ProductFormOption from '~async/product-form/product-form-option/product-form-option'
import ArtDirection from '~global/images/art-direction.vue'

import IconLoading from '~icons/misc/loading.svg'
import IconTick from '~icons/misc/tick.svg'
import { formatMoney } from '@shopify/theme-currency'
import classes from '~/config/classes'

/**
 * Returns the default selected options based on the given variant.
 * - If no variant is given, options are empty by default.
 *
 * @param {Object} variant - Optional variant object.
 * @returns {Object}
 */
function getDefaultSelectedOptions(variant) {
  if (!variant) {
    return {}
  }

  return variant.selectedOptions.reduce((accumulator, current) => {
    accumulator[current.name] = current.value
    accumulator[current.variant] = variant

    return accumulator
  }, {})
}

export default {
  name: 'ProductForm',

  components: {
    Btn,
    IconLoading,
    Overlay,
    ProductFormOption,
    ArtDirection
  },

  props: {
    group: {
      type: [Boolean, String],
      default: '',
    },
    isGiftCard: {
      type: Boolean,
      default: false,
    },
    liquid: {
      type: Object,
      default: () => ({
        hasOnlyDefaultVariant: false,
        enable_preorder: false,
      }),
    },
    parentState: {
      type: String,
      default: 'loading',
    },
    product: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
    sizeGuide: {
      type: String,
      default: '',
    },
    sizeTitle: {
      type: String,
      default: '',
    },
    sizeBody: {
      type: String,
      default: '',
    },
    sizePageCm: {
      type: String,
      default: '',
    },
    sizePageIn: {
      type: String,
      default: '',
    },
    sizeGuideRightImage: {
      type: String,
      default: '',
    },
    sizeGuideLeftImage: {
      type: String,
      default: '',
    },
    variant: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
    enablePreorder: {
      type: Boolean,
      default: false,
    },
    klaviyoFormId: {
      type: String,
      default: '',
    },
    klaviyoFormIdMobile: {
      type: String,
      default: '',
    },
  },

  emits: {
    'update-variant': (payload) => typeof payload === 'object',
  },

  data() {
    return {
      currentVariantId: this.variant?.id || 0,
      email: '',
      error: '',
      lineItemProperties: {},
      quantity: 1,
      state: 'ready',
      timeout: {},
      selectedOptions: getDefaultSelectedOptions(this.variant),
      stockNotification: {
        state: 'IDLE',
      },
    }
  },

  computed: {

    /**
     * Map Vuex getters.
     */
    ...mapGetters({
      getComponentExists: 'components/getExists',
    }),

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Returns the product options.
     * @returns {Array}
     */
    options() {
      if (this.product?.options) {
        return this.product.options
      }

      return this.liquid.options
    },

    /**
     * Returns if viewing store in different currency to base
     * @returns {Boolean}
     */
    isDifferentCurrency() {
      return window.cnvs.store.baseCurrency !== window.cnvs.store.currency
    },

    /**
     * Compute add to cart icon.
     * @returns {String}
     */
    addToCartIcon() {
      return this.state === 'added' ? IconTick : false
    },

    /**
     * Compute add to cart text.
     * @returns {String}
     */
    addToCartText() {
      if (this.$variable('product.enableStockNotifications')) {
        if (
          this.parentState === 'loading' &&
          (this.liquid?.waitingList || !this.liquid?.available)
        ) {
          return this.$string('product.cta.stock_notification')
        }

        if (this.product) {
          const variantAvailable = this.variant && !this.variant.available
          const productAvailable = !this.product.available

          const waitingListNonVipProduct = this.liquid?.waitingList && !this.product.vipProduct

          const waitingListVipProductNonVipCustomer =
            this.liquid?.waitingList &&
            this.product.vipProduct &&
            !this.liquid.customer.vip

          if (
            variantAvailable ||
            productAvailable ||
            waitingListNonVipProduct ||
            waitingListVipProductNonVipCustomer
          ) {
            return this.$string('product.cta.stock_notification')
          }
        }
      }

      return this.state === 'added'
        ? this.$string('product.cta.added_to_cart')
        : this.$string('product.cta.add_to_cart')
    },

    /**
     * Compute has only default variant from Liquid and product objects.
     * @returns {Boolean}
     */
    hasOnlyDefaultVariant() {
      return (
        this.liquid.hasOnlyDefaultVariant || this.product.hasOnlyDefaultVariant
      )
    },

    /**
     * Returns the product's model details.
     * @returns {String}
     */
    modelDetails() {
      if (this.product?.modelDetails) {
        return this.product.modelDetails.value
      }

      return this.liquid.modelDetails
    },

    /**
     * Compute product siblings.
     * - Only show if group and colour are set.
     * - Don't show if waiting list product and customer isn't VIP.
     * - Don't show if product is a gift card.
     * @returns {Array}
     */
    productSiblings() {
      let showProductSiblings = false

      if (this.group && this.liquid.colour) {
        showProductSiblings = true
      }

      if (
        (this.liquid.waitingList && !this.liquid.customer?.vip) ||
        this.isGiftCard
      ) {
        showProductSiblings = false
      }

      if (!showProductSiblings) {
        return []
      }

      if (this.parentState === 'loading') {
        return Array(3)
          .fill(null)
          .map((_, index) => {
            return {
              asImage: true,
              disabled: false,
              image: index === 0 ? { src: this.liquid.featuredImage } : {},
              label: index === 0 ? this.liquid.title : '',
              selected: index === 0,
              title: index === 0 ? this.liquid.colour : '',
              url: index === 0 ? this.liquid.url : '',
            }
          })
      }

      return this.product?.siblings
    },

    /**
     * Size Guide content
     * returns {String}
     */
     sizePageCmText() {
      if (this.sizePageCm) {
        return this.sizePageCm
      }

      return ''
    },


    /**
     * Compute subscription object for Klaviyo.
     * - https://developers.klaviyo.com/en/reference/create_client_subscription
     * - https://developers.klaviyo.com/en/reference/create_client_back_in_stock_subscription
     * @returns {Object}
     */
    klaviyoSubscription() {
      const type = this.liquid?.waitingList
        ? 'subscription'
        : 'back-in-stock-subscription'

      const attributes = this.liquid?.waitingList
        ? { custom_source: 'waiting_list' }
        : { channels: ['EMAIL'] }

      const relationships = this.liquid?.waitingList
        ? {
          list: {
            data: {
              type: 'list',
              id: this.liquid?.waitingList,
            },
          },
        }
        : {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${this.currentVariantId}`,
            },
          },
        }

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2024-10-15',
        },
        body: JSON.stringify({
          data: {
            type,
            attributes: {
              ...attributes,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: this.email,
                  },
                },
              },
            },
            relationships,
          },
        }),
      }

      const url = this.liquid?.waitingList
        ? `https://a.klaviyo.com/client/subscriptions?company_id=${this.$variable(
          'klaviyo.key',
        )}`
        : `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.$variable(
          'klaviyo.key',
        )}`

      return {
        options,
        url,
      }
    },

    /**
     * Compute whether to show product form options.
     * - Written in long-form to make it easier to understand.
     * - Hide if only default variant.
     * - Hide if product is on a waiting list, unless product is VIP.
     * - VIP products can be added to cart if customer is a VIP.
     * @returns {Boolean}
     */
    showOptions() {
      if (this.hasOnlyDefaultVariant) {
        return false
      }

      if (this.liquid?.waitingList) {
        if (this.product?.vipProduct && this.liquid.customer.vip) {
          return true
        }

        return false
      }

      return true
    },

    /**
     * Returns whether to show pre-order instead of add to cart
     * @returns {Boolean}
     */
    isPreOrder() {
      return this.enablePreorder || false
    },
  },

  watch: {

    /**
     * Watch currentVariantId to update Canvas variant when select changes.
     */
    currentVariantId() {
      if (this.variant.id === this.currentVariantId) {
        return
      }

      const variant = this.getVariantFromId(this.currentVariantId)

      if (!variant) {
        return
      }

      this.error = ''

      this.$emit('update-variant', variant)
      this.resetStockNotification()
    },

    /**
     * Watch product to update selected variant when product data is loaded.
     */
    product() {
      this.getCurrentVariant()
      this.quantity = 1
    },

    variant: {

      /**
       * Sets the default selected options when the variant changes.
       */
      handler() {
        this.selectedOptions = getDefaultSelectedOptions(this.variant)
      },
      deep: true,
    },

    selectedOptions: {

      /**
       * Watches for changes to the selected options object.
       */
      handler() {
        const variant = this.product.variants.find(({ selectedOptions }) => selectedOptions.every(
          (option) => this.selectedOptions[option.name] === option.value,
        ))

        if (!variant) {
          return
        }

        this.currentVariantId = variant.id
      },
      deep: true,
    },
  },

  mounted() {
    this.getCurrentVariant()
    this.setSelectors()
    this.setEventListeners()
    this.setDefaultState()
  },

  methods: {

    /**
     * Sets the node selectors.
     */
     setSelectors() {
      const container = document.querySelector(
        `[js-size-guide="${this.liquid.sectionId}"]`,
      )

      this.selectors = {
        container,
        button: container.querySelectorAll('[js-size-guide="button"]'),
        page: container.querySelectorAll('[js-size-guide="page"]'),
        state: container.querySelector('[js-size-guide="state"]'),
      }
    },

    /**
     * Sets and handles the event listeners.
     */
    setEventListeners() {
      this.selectors.button.forEach((button) => {
        if(!button) {
          return
        }

        button.addEventListener('click', (event) => {
          const id = event.target.getAttribute('aria-controls')
          this.selectors.button.forEach((button) => {
            const controls = button.getAttribute('aria-controls')

            if (controls === id) {
              button.classList.add(classes.active)
              this.positionStateByElement(button)
              return
            }

            button.classList.remove(classes.active)
          })

          this.setActivePage(id)
          this.setDefaultState()
        })

        cnvs.EventBus.listen('cnvs:resize', () => {
          this.setDefaultState()
        })
      })
    },

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      addItem: 'cart/addItem',
      openOverlay: 'overlays/open',
      closeOverlay: 'overlays/close',
    }),

    /**
     * Get current variant on page load or product update.
     */
    getCurrentVariant() {
      if (!this.product || !this.product?.variants?.length) {
        return
      }

      if (this.variant) {
        this.currentVariantId = this.variant.id
        return
      }

      if (this.hasOnlyDefaultVariant) {
        this.currentVariantId = this.product.variants[0].id
        return
      }

      if (this.getVariantFromUrl()) {
        this.currentVariantId = this.getVariantFromUrl().id
      }
    },

    /**
     * Get initial variant from URL parameter.
     * @returns {Object}
     */
    getVariantFromUrl() {
      const params = new URLSearchParams(document.location.search.substring(1))
      const variantId = Number(params.get('variant'))
      return this.getVariantFromId(variantId)
    },

    /**
     * Get variant object from variant ID.
     * @returns {Object}
     */
    getVariantFromId(variantId) {
      return this.product.variants.find((variant) => {
        return variant.id === variantId
      })
    },

    /**
     * Get variant title.
     * @param {Object} variant - Variant object.
     * @returns {String}
     */
    getVariantTitle(variant) {
      return variant.available
        ? variant.title
        : `${variant.title} - ${this.$string('product.form.sold_out')}`
    },

    /**
     * Handle add to cart submission.
     */
    async handleAddToCart() {

      /**
       * Show back in stock sign-up modal for the below:
       * - If product is on a waiting list.
       * - Or it's VIP on a waiting list but the customer isn't a VIP.
       */
      if (
        (this.liquid?.waitingList && !this.product.vipProduct) ||
        (this.liquid?.waitingList &&
          this.product.vipProduct &&
          !this.liquid.customer.vip)
      ) {
        let firstAvailableVariant = this.product.variants.find((variant) => {
          return variant.available
        })

        if (!firstAvailableVariant) {
          firstAvailableVariant = this.product.variants[0]
        }

        this.currentVariantId = firstAvailableVariant.id

        this.openOverlay({
          namespace: 'stockNotificationOverlay',
          ignoreDismissed: true,
        })

        return
      }

      if (!this.variant) {
        this.error = this.isGiftCard
          ? this.$string('product.form.gift_card_prompt')
          : this.$string('product.form.prompt')

        return
      }

      if (
        this.$variable('product.enableStockNotifications') &&
        !this.variant.available
      ) {
        this.openOverlay({
          namespace: 'stockNotificationOverlay',
          ignoreDismissed: true,
        })
        return
      }

      clearTimeout(this.timeout)

      this.error = ''
      this.state = 'adding'

      if (cnvs.storybook) {
        this.timeout = setTimeout(() => {
          this.state = 'added'
        }, this.$timing('slow'))

        this.timeout = setTimeout(() => {
          this.state = 'ready'
        }, this.$timing('message'))

        return
      }

      const items = [
        {
          id: this.variant.id,
          properties: this.lineItemProperties,
          quantity: this.quantity,
        },
      ]

      try {
        await this.addItem(items)
        this.state = 'added'

        if (this.getComponentExists('cart-drawer')) {
          this.openOverlay({
            component: 'cart-drawer',
            ignoreDismissed: true,
            namespace: 'cartDrawer',
          })
        }

        await this.resetState()
      } catch (error) {
        this.state = 'error'

        if (error?.description) {
          this.error = error.description
          return
        }

        reportError('Failed to add product to cart', error)
      }
    },

    /**
     * Handles the stock notification submission.
     */
    async handleStockNotification() {
      if (this.stockNotification.state === 'LOADING') {
        return
      }

      this.stockNotification.state = 'LOADING'

      try {
        const response = await fetch(
          this.klaviyoSubscription.url,
          this.klaviyoSubscription.options,
        )

        if ([200, 202].includes(response.status)) {
          this.stockNotification.state = 'SUCCESS'
          return
        }

        this.stockNotification.state = 'ERROR'
      } catch {
        this.stockNotification.state = 'ERROR'
      }
    },

    /**
     * Resets the stock notification state.
     */
    resetStockNotification() {
      this.stockNotification.state = 'IDLE'
    },

    /**
     * Formats given option values into a compatible object.
     * @param {Array} values - The option values.
     * @returns {Array}
     */
    formatOptionValues(option) {
      const titles = {
        XS: 'Extra Small',
        S: 'Small',
        M: 'Medium',
        L: 'Large',
        XL: 'Extra Large',
        XXL: 'Extra Extra Large',
      }

      return option.values
        .map((value) => {
          let optionVariant

          if (this.product.variants) {
            this.product.variants.forEach((variant) => {
              variant.selectedOptions.forEach((selectedOption) => {
                if (
                  selectedOption.name.toLowerCase() === 'value' &&
                  selectedOption.value === value
                ) {
                  optionVariant = variant
                }
              })
            })
          }

          /**
           * Add additional test to gift card to remove options that don't match
           * any variants - storefront API was returning a £10,000 option which
           * doesn't exist for some reason.
           */
          if (this.isGiftCard) {
            const variants = this.liquid.variants || this.product?.variants

            const matchedVariant = variants?.find((variant) => {
              const variantOption = variant.selectedOptions.find(({ name }) => {
                return name === option.name
              })

              return variantOption && variantOption.value === value
            })

            if (!matchedVariant) {
              return false
            }
          }

          return {
            label: value,
            title: titles[value],
            optionVariant,
            selected:
              (this.selectedOptions[option.name] &&
                this.selectedOptions[option.name] === value) ??
              false,
            disabled: this.getValueDisabledState(option.name, value),
          }
        })
        .filter(Boolean)
    },

    /**
     * Handles the option change event.
     * @param {String} name - The option name.
     * @param {String} value - The selected value.
     */
    handleOptionChange({ name, value }) {
      if (!name || !value) {
        return
      }

      if (this.isGiftCard) {
        const element = document.querySelector('.main-product__price')

        if (this.product.variants) {
          this.product.variants.forEach((variant) => {
            variant.selectedOptions.forEach((option) => {
              if (option.name !== name || option.value !== value) {
                return
              }
              const variantPrice = Math.round(variant.price.amount / 100) * 100
              let formatString = `${window.cnvs.store.currencySymbol}{{amount}}`
              if (window.cnvs.store.currencySymbol === 'CHF') {
                formatString = `${window.cnvs.store.currencySymbol} {{amount}}`
              }
              element.innerText = formatMoney(
                variantPrice,
                formatString,
              ).replace('.00', '')
            })
          })
        }
      }

      this.selectedOptions[name] = value
    },

    /**
     * Reset product form state after adding to cart after message delay.
     * @param {Boolean} resetVariant - Resets the selected variant.
     */
    async resetState(resetVariant = false) {
      await new Promise((resolve) => {
        setTimeout(resolve, this.$timing('message'))
      })

      this.state = 'ready'
      this.quantity = 1

      if (!resetVariant) {
        return
      }

      /**
       * Revert to first available variant.
       * - If there isn't one (product out of stock) then select first variant.
       */
      let firstAvailableVariant = this.product.variants.find((variant) => {
        return variant.available
      })

      if (!firstAvailableVariant) {
        firstAvailableVariant = this.product.variants[0]
      }

      this.currentVariantId = firstAvailableVariant.id
    },

    /**
     * Returns the disabled state for a option value.
     *
     * @param {string} optionName - The option name.
     * @param {string} optionValue - The value to check.
     * @returns {boolean} - The disabled state.
     */
    getValueDisabledState(optionName, optionValue) {
      if (!this.product) {
        return false
      }

      /**
       * If there's only one option, simply find the variant and return it's
       * availability.
       */
      if (this.options.length === 1) {
        const variant = this.product.variants.find((item) => {
          const option = item.selectedOptions.find(({ name }) => {
            return name === optionName
          })

          return option && option.value === optionValue
        })

        return !variant?.available
      }

      /**
       * If there's more than one option + the option is the primary one it will
       * never be disabled.
       */
      if (this.options[0].name === optionName) {
        return false
      }

      /**
       * Find variants which have both the first option's value and this value.
       */
      const variants = this.product.variants.filter((variant) => {
        const firstOption = this.options[0].name

        if (!variant.available) {
          return false
        }

        const first = variant.selectedOptions.find(
          (option) => option.name === firstOption &&
            option.value === this.selectedOptions[firstOption],
        )

        const current = variant.selectedOptions.find(
          (option) => option.name === optionName && option.value === optionValue,
        )

        return first && current
      })

      return variants.length <= 0
    },

    /**
     * Returns the link object for the given option.
     * @param {Object} option - The option object.
     * @returns {Object|false}
     */
    getOptionLink(option) {
      if (!this.sizeGuide || option.name !== 'Size') {
        return false
      }

      return {
        label: this.$string('product.form.size_guide'),
        url: this.sizeGuide,
      }
    },

    /**
     * Handle pre-order click
     */
    handlePreOrder() {
      const formId = this.isMobile && this.liquid?.klaviyoFormIdMobile
        ? this.liquid.klaviyoFormIdMobile
        : this.liquid?.klaviyoFormId

      console.log('DEBUG - Klaviyo form ID:', formId)

      if (!formId) {
        console.error('No Klaviyo form ID provided in section settings')
        return
      }

      window._klOnsite = window._klOnsite || []
      window._klOnsite.push(['openForm', formId])
    },

    /**
     * Size guide button click event
     */

    /**
     * Returns the active control element.
     * @returns {HTMLElement}
     */
     getActiveControlElement() {
      return Array.from(this.selectors.button).find(
        (element) => element.classList.contains(classes.active),
      )
    },

    /**
     * Positions the state by the given element.
     * @param {HTMLElement} element - The element to position by.
     */
    positionStateByElement(element) {
      if (!this.selectors.state || !element || !element.offsetWidth) {
        return
      }

      this.selectors.state.style.width = `${element.offsetWidth}px`
      this.selectors.state.style.left = `${element.offsetLeft}px`
    },

    /**
     * Sets the default state.
     */
    setDefaultState() {
      const control = this.getActiveControlElement()

      if (!this.selectors.state || !control) {
        return
      }

      this.positionStateByElement(control)
    },

    /**
     * Sets the active page item.
     * @param {String} id - The page identifier.
     */
     setActivePage(id) {
      this.selectors.page.forEach((page) => {
        if (page.id === id) {
          page.classList.add(classes.active)
          return
        }

        page.classList.remove(classes.active)
      })
    },
  },
}
</script>

<style lang="scss">
@import "./product-form";
</style>
